module.exports = function(e) {
  this.limit = e.target.value;
  this.setPage(1);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/set-limit.js